// extracted by mini-css-extract-plugin
export default {"contactLink":"contact_contactLink__7HT5Q"};